import { queryOptions } from '@tanstack/react-query';

import { merchantApi } from './merchant.api';

export const queryKeys = {
    all: ['merchant'] as const,
    onboardingStatus: () => [...queryKeys.all, 'onboarding-status'] as const,
};

export function merchantOnboardingStatusOptions() {
    return queryOptions({
        queryKey: queryKeys.onboardingStatus(),
        queryFn: ({ signal }) => merchantApi.getOnboardingStatus(signal),
        refetchOnWindowFocus: 'always',
        refetchOnReconnect: 'always',
    });
}
